<template>
  <div>
    <section class="section--actions-page">
      <component :if="componentName" :is="componentName" />
      <div v-if="vtbl_show_search">
        <filter-barevalutation
          ref="filterBar"
          @vuetable-filterBar:doFilter="onDoFilter"
          @vuetable-filterBar:resetFilter="onResetFilter"
        >
        </filter-barevalutation>
      </div>
      <div class="actions--group" v-if="vtbl_show_bulk">
        <div class="dropdown">
          <div class="dropdown--select">
            <i class="fal fa-bars"></i>
            <span>Azioni</span>
            <i class="fas fa-caret-down"></i>
          </div>
          <div class="dropdown--options">
            <a
              v-if="bulk_change_status_url"
              href="#"
              @click="bulkChangeStatus()"
              ><i class="fal fa-pen-square"></i> Change Status</a
            >
            <a v-if="bulk_change_role_url" href="#" @click="bulkChangeRoles()"
              ><i class="fal fa-users"></i> Change Roles</a
            >
          </div>
        </div>
        <a
          v-if="this.columnsSelectorUrl !== undefined"
          href="#"
          @click="openCoulmnsSelector()"
        >
          <i class="fas fa-wrench"></i>
        </a>
      </div>
    </section>
    <div class="outer">
      <i
        @click="handleLeftScrollTable()"
        class="fal fa-angle-left prev-column"
      ></i>
      <i
        @click="handleRightScrollTable()"
        class="fal fa-angle-right next-column"
      ></i>
      <div class="table-container">
        <vuetable
          ref="vuetable"
          class="fixed-columns"
          id="vue_table_component"
          track-by="item_code"
          :api-url="this.vtbl_url"
          :fields="this.vtbl_fields"
          :sort-order="this.vtbl_sort_order"
          :track-by="this.vtbl_fields.id"
          :append-params="moreParams"
          :per-page="this.perPage"
          pagination-path=""
          @vuetable:load-success="onLoadSuccess"
          @vuetable:pagination-data="onPaginationData"
          @vuetable:checkbox-toggled="onCheckboxToggled"
          @vuetable:checkbox-toggled-all="onCheckboxToggledAll"
        >
          <template slot="actions" slot-scope="props">
            <div class="actions custom-actions">
              <button
                class="btn btn--mini btn--only-icon btn--transparent circle-button"
                type="button"
                v-if="hasButton('documents')"
                @click="
                  handleAction('documents', props.rowData, props.rowIndex)
                "
              >
                <i class="fas fa-file-alt"></i>
              </button>
              <button
                class="btn btn--mini btn--only-icon btn--transparent circle-button"
                type="button"
                v-if="hasButton('show')"
                @click="handleAction('show', props.rowData, props.rowIndex)"
              >
                <i class="fas fa-eye"></i>
              </button>
              <button
                class="btn btn--mini btn--only-icon btn--transparent circle-button"
                type="button"
                v-if="hasButton('edit')"
                @click="handleAction('edit', props.rowData, props.rowIndex)"
              >
                <i class="fas fa-pencil"></i>
              </button>
              <button
                class="btn btn--mini btn--only-icon btn--transparent circle-button"
                type="button"
                v-if="hasButton('delete')"
                @click="handleAction('delete', props.rowData, props.rowIndex)"
              >
                <i class="fas fa-trash-alt"></i>
              </button>
            </div>
          </template>
        </vuetable>
      </div>
    </div>

    <div v-if="this.vtbl_show_paginator" class="vuetable-pagination">
      <!--<vuetable-pagination-info
                ref="paginationInfo"
                infoTemplate="Risultati da {from} a {to} di {total}">
            </vuetable-pagination-info>-->
      <vuetable-pagination
        ref="pagination"
        v-on:vuetable-pagination:change-page="onChangePage"
      >
      </vuetable-pagination>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.componentName = this.component_filters_name;
    this.columnsSelectorUrl = this.vtbl_columns_selector;
  },

  data() {
    return {
      itemsSelected: [],
      moreParams: {},
      perPage: 10,
      renderedItems: [],
      tableHeight: "100px",
      componentName: "",
      columnsSelectorUrl: "",
      removeHeader: this.vtbl_remove_header,
      removePaginator: this.vtbl_remove_paginator,
    };
  },

  watch: {
    perPage: function (val, oldVal) {
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
  },

  methods: {
    openCoulmnsSelector() {
      app.__vue__.$refs.vue_popup.toggle("", this.columnsSelectorUrl);
    },

    handleRightScrollTable() {
      var theLeft = $("#vue_table_component");
      var leftAmount = theLeft.scrollLeft();
      theLeft.animate(
        {
          scrollLeft: (leftAmount += 300),
        },
        200,
      );
    },
    handleLeftScrollTable() {
      var theLeft = $("#vue_table_component");
      var leftAmount = theLeft.scrollLeft();
      theLeft.animate(
        {
          scrollLeft: (leftAmount -= 400),
        },
        200,
      );
    },
    hasButton(button) {
      let buttonVisible = false;
      for (let i = 0; i < this.default_actions_configuration.length; i++) {
        let buttonConfiguration = this.default_actions_configuration[i];
        if (buttonConfiguration.name == button) buttonVisible = true;
      }
      return buttonVisible;
    },

    handleAction(button, rowData, index) {
      for (let i = 0; i < this.default_actions_configuration.length; i++) {
        let buttonConfiguration = this.default_actions_configuration[i];
        if (buttonConfiguration.name == button) {
          if (buttonConfiguration.actionType == "load_component") {
            this.actionLoadComponent(buttonConfiguration, rowData);
          }
          if (buttonConfiguration.actionType == "popup") {
            this.actionPopup(buttonConfiguration, rowData);
          }
          if (buttonConfiguration.actionType == "sidebar") {
            this.actionSidebar(buttonConfiguration, rowData);
          }
          if (buttonConfiguration.actionType == "url") {
            this.actionUrl(buttonConfiguration, rowData);
          }
          if (buttonConfiguration.actionType == "tab") {
            this.actionTab(buttonConfiguration, rowData);
          }
          if (buttonConfiguration.actionType == "delete") {
            this.actionDelete(buttonConfiguration, rowData);
          }
          if (buttonConfiguration.actionType == "deletePivot") {
            this.actionDeletePivot(buttonConfiguration, rowData);
          }
        }
      }
    },
    actionLoadComponent(buttonConfiguration, item) {
      let component_reference = buttonConfiguration.component.reference;
      //Check for question_id -> survey_question
      if (component_reference.startsWith("component_")) {
        component_reference = component_reference.replace(
          "[component_id]",
          item.question_id,
        );
      }
      eval("app.__vue__.$refs." + eval("component_reference")).toggle(
        decodeURI(buttonConfiguration.action).replace("[id]", item.id),
        item.id,
        true,
        buttonConfiguration.component,
      );
    },
    actionPopup(buttonConfiguration, item) {
      //console.log(this.$parent.$refs.vue_popup.toggle("/fillModal"));
      app.__vue__.$refs.vue_popup.toggle(
        buttonConfiguration.popupTitle,
        decodeURI(buttonConfiguration.action).replace("[id]", item.id),
      );
    },
    actionSidebar(buttonConfiguration, item) {
      app.__vue__.$refs.vue_sidebar.toggle(
        decodeURI(buttonConfiguration.action).replace("[id]", item.id),
      );
    },
    actionUrl(buttonConfiguration, item) {
      location.href = decodeURI(buttonConfiguration.action).replace(
        "[id]",
        item.id,
      );
    },
    actionTab(buttonConfiguration, item) {
      window.open(
        decodeURI(buttonConfiguration.action).replace("[id]", item.id),
        "_blank", // <- This is what makes it open in a new window.
      );
    },
    actionDelete(buttonConfiguration, item) {
      Vue.swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.value) {
            axios
              .delete(
                decodeURI(buttonConfiguration.action).replace("[id]", item.id),
              )
              .then(() => location.reload());
          }
        });
    },
    actionDeletePivot(buttonConfiguration, item) {
      Vue.swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.value) {
            let action = decodeURI(buttonConfiguration.action);
            action +=
              "?" + buttonConfiguration.parameter_name + "=" + item.pivot.id;
            axios.delete(action).then(() => location.reload());
          }
        });
    },

    onLoadSuccess(datas) {
      this.renderedItems = datas.data.data;
      //console.log(this.renderedItems);
    },

    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      //this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onCheckboxToggled(checked, item) {
      if (checked) this.itemsSelected.push(item);
      if (!checked)
        this.itemsSelected = this.itemsSelected.filter((x) => x.id !== item.id);
      //console.log(this.itemsSelected);
    },
    onCheckboxToggledAll(checked) {
      if (checked) {
        this.itemsSelected = this.renderedItems;
      } else {
        this.itemsSelected = [];
      }
    },
    onDoFilter(filterText) {
      this.moreParams = {
        filter: filterText,
        filter_by: this.$refs.filterBar.$refs.filterSelected.value,
      };
      Vue.nextTick(() => this.$refs.vuetable.refresh());
      //console.log(this.moreParams);
    },
    onResetFilter() {
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    formatDate(value, fmt = "D MMM YYYY") {
      return value == null ? "" : this.$moment(value, "YYYY-MM-DD").format(fmt);
    },

    bulkChangeStatus() {
      if (this.itemsSelected.length == 0) {
        Vue.swal.fire({
          title: "No charts selected",
          text: "Select at least one chart",
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return;
      }
      let items = this.itemsSelected
        .map(function (item) {
          return "&item_id[]=" + item.id;
        })
        .join("");
      app.__vue__.$refs.vue_sidebar.toggle(
        decodeURI(this.bulk_change_status_url + "?parms=start" + items),
      );
    },
    bulkChangeRoles() {
      if (this.itemsSelected.length == 0) {
        Vue.swal.fire({
          title: "No charts selected",
          text: "Select at least one chart",
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return;
      }
      let items = this.itemsSelected
        .map(function (item) {
          return "&item_id[]=" + item.id;
        })
        .join("");
      app.__vue__.$refs.vue_sidebar.toggle(
        decodeURI(this.bulk_change_role_url + "?parms=start" + items),
      );
    },

    bulkDelete() {
      app.__vue__.actionBulkDelete("routeTest", this.itemsSelected);
    },
    sendEmail(email_type) {
      let items = app.__vue__.$refs.people_index_vuetable.$data.itemsSelected;
      let item_ids = items.map(function (item) {
        return item.id;
      });

      let idsStrings = "";
      for (let i = 0; i < item_ids.length; i++) {
        idsStrings += "id[]=" + item_ids[i] + "&";
      }
      idsStrings = idsStrings.substring(0, idsStrings.length - 1);

      if (item_ids.length < 1) {
        Vue.swal.fire({
          title: "No people selected",
          text: "Select at least one person",
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return false;
      }
      app.__vue__.$refs.vue_sidebar.toggle(
        decodeURI(
          this.sendmail_url + "?email_type=" + email_type + "&" + idsStrings,
        ),
      );
    },
  },
  created: function () {},

  props: {
    component_filters_name: {
      type: String,
      required: false,
    },
    vtbl_url: {
      type: String,
      required: true,
    },
    vtbl_fields: {
      type: Array,
      required: true,
    },
    vtbl_sort_order: {
      type: Array,
      required: false,
      default: () => [
        {
          field: "id",
          direction: "desc",
        },
      ],
    },
    vtbl_columns_selector: {
      type: String,
      required: false,
    },
    exportxls_url: {
      type: String,
      required: false,
    },
    bulk_change_status_url: {
      type: String,
      required: false,
    },
    bulk_change_role_url: {
      type: String,
      required: false,
    },
    resetpassword_url: {
      type: String,
      required: false,
    },
    bulkdelete_url: {
      type: String,
      required: false,
    },

    vtbl_show_search: {
      type: Boolean,
      required: false,
      default: true,
    },
    vtbl_show_bulk: {
      type: Boolean,
      required: false,
      default: true,
    },
    vtbl_show_paginator: {
      type: Boolean,
      required: false,
      default: true,
    },
    default_actions_configuration: {
      type: Array,
      default: () => [
        {
          name: "edit",
          action: location.href + "/[id]/edit",
          actionType: "url",
        },
        {
          name: "delete",
          action: location.href + "/[id]",
          actionType: "delete",
        },
      ],
    },
  },
};
</script>

<style scoped>
.circle-button {
  flex: 0 0 32px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.circle-button i {
  margin-left: 0px;
}
.circle-button:hover {
  color: white !important;
}

.vuetable-body {
  background-color: red !important;
}
</style>
